import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import Modal from '../../components/Modal'
import { updateDiscount } from '../../actions/ClientActions'

@connect(state => ({
    isUpdatingDiscount: state.modal.isUpdatingDiscount,
    errorUpdatingDiscount: state.modal.errorUpdatingDiscount,
}))
export default class UpdateDiscountModal extends Component {
    static propTypes = {
        client: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }),
    }

    constructor(props) {
        super(props)
        this.state = {
            newDiscount: this.props.client.discount,
        }
    }

    update() {
        this.props.dispatch(
            updateDiscount(this.props.client.id, this.state.newDiscount)
        )
    }

    handleUpdateDiscount(event) {
        this.setState({
            newDiscount: event.target.value,
        })
    }

    render() {
        var actionButton = this.props.isUpdatingDiscount ? (
            <button className="btn btn-success disabled">Updating...</button>
        ) : (
            <button
                className="btn btn-success"
                onClick={this.update.bind(this)}
            >
                Update
            </button>
        )

        return (
            <Modal
                actionButton={actionButton}
                className="modal modal-success"
                title={'Update Discount'}
            >
                <div
                    style={{ display: 'flex', justifyContent: 'space-around' }}
                >
                    <h3>New Discount:</h3>
                    <input
                        type="range"
                        value={this.state.newDiscount}
                        style={{ flex: 0.6 }}
                        min="0"
                        max="100"
                        onChange={this.handleUpdateDiscount.bind(this)}
                    />
                    <input
                        type="number"
                        id="discountText"
                        min="0"
                        max="100"
                        value={this.state.newDiscount}
                        onChange={this.handleUpdateDiscount.bind(this)}
                    />
                </div>
                <p
                    className="text-muted"
                    style={{
                        fontSize: 10,
                        paddingTop: 10,
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    Client will continue to enjoy the applied discount until
                    manually changed.
                </p>
                {this.props.errorUpdatingDiscount && (
                    <p
                        className="text-danger"
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        Error updating discount!
                    </p>
                )}
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/clients/UpdateDiscountModal.js